<template>
  <div
    ref="wrapper"
    class="dateTimePickerWrapper time-picker"
  >
    <input-mix-group
      middle="~"
    >
      <date-time-picker
        slot="first-input"
        v-model="innerStartTime"
        :flow="['time']"
        type="time"
        input-name="start-time"
        format="HH:mm"
        without-input-group
        :read-only="readonly"
      />
      <date-time-picker
        slot="last-input"
        v-model="innerEndTime"
        :flow="['time']"
        type="time"
        input-name="end-time"
        format="HH:mm"
        without-input-group
        :read-only="readonly"
      />
    </input-mix-group>
  </div>
</template>
<script>
import InputMixGroup from '~components/common/form/input/MixGroup'
import DateTimePicker from '~lar/DateTimePicker'

export default {
  name: 'TimePicker',
  components: {
    InputMixGroup,
    DateTimePicker
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    inputName: {
      type: String,
      required: true
    },
    readonly: Boolean
  },
  data () {
    return {
      isOpen: false,
      innerStartTime: '',
      innerEndTime: ''
    }
  },
  computed: {
    innerTimes () {
      return {
        start_time: this.$moment(this.innerStartTime).format('YYYY-MM-DD HH:mm'),
        end_time: this.$moment(this.innerEndTime).format('YYYY-MM-DD HH:mm')
      }
    }
  },
  watch: {
    innerTimes (newValue) {
      this.$emit('input', newValue)
    },
    value (newValue) {
      this.setValue()
    }
  },
  created () {
    if (Object.keys(this.value)) {
      this.setValue()
    }
  },
  methods: {
    setValue () {
      this.innerStartTime = this.$moment(this.value.start_time).toISOString()
      this.innerEndTime = this.$moment(this.value.end_time).toISOString()
    }
  }
}
</script>
